//import { ScatterSeriesConfiguration } from '../../widgets/models';
import { PeriodReference, AggregationConfiguration, TimeInterval, IPeriodConfiguration } from '../../models';
import { ChartConfigurationOption } from '../../wtFramework';
import { SeriesConfiguration } from '../../widgets';

export class ScatterConfiguration implements IPeriodConfiguration {
        series: SeriesConfiguration[];
        options: ChartConfigurationOption;
        aggregation: AggregationConfiguration;
        minPeriod: TimeInterval;
        maxPeriod: TimeInterval;
        alignedOn: PeriodReference;
        isEndDateIncluded = false;
        nameConfiguration: any;
        shapes: any[];

        constructor() {
            this.series = [];
            this.options = new ChartConfigurationOption();
            this.aggregation = new AggregationConfiguration();
            this.alignedOn = 0;
        }
}